// import external dependencies

import "jquery"
import "slick-carousel";
import AOS from 'aos'
import 'jarallax/dist/jarallax';
import "isotope-layout/dist/isotope.pkgd.min"

// Import everything from autoload
import "./autoload/_bootstrap.js"
import "./modules/_header"
import heroSlider from "./modules/_hero-slider"
import playOnClick from "./modules/_play-video"
import beforeAfterSlider from "./modules/_before-after-slider"
import proceduresFilter from "./modules/_filter-procedures"
import "./modules/gallery"

jQuery(document).ready(() => {
	$('.right-button').click(function () {
		$(this).next().css('transform', 'translateX(0)')
	});

	if ($('.img-placeholder').length) {
		playOnClick();
	}

	heroSlider();
	beforeAfterSlider();

	//Featured Procedures Toggle Class
	function featuredToggleClass() {
		const featuredEl = $('.featured-block');
		const featuredBtn = $('.featured-block a');

		featuredEl.click(function (e) {
			if ($(window).width() < 992) {
				if (!$(e.target).is(featuredBtn)) {
					e.preventDefault();
					$('.featured-items').find('.featured-block.hover').removeClass('hover');
					$(this).toggleClass("hover");
				}
			}
		});

		featuredEl.mouseover(function () {
			if ($(window).width() > 991) {
				$('.featured-items').find('.featured-block.hover').removeClass('hover');
				$(this).toggleClass('hover');
			}
		});

		featuredEl.mouseout(function () {
			$('.featured-items').find('.featured-block.hover').removeClass('hover');
		});
	}

	function featuredResetClass() {
		const featuredEl = $('.featured-block');

		featuredEl.removeClass('hover');
	}

	$(window).resize(function () {
		featuredResetClass();
		featuredToggleClass();
	});

	featuredToggleClass();
});

window.onload = () => {
	const firstSlide = document.querySelector('.slick-active .first-slide');
	const interiorHeaderMain = document.querySelector('.interior-header__main');
	const procedures = document.querySelector('.featured-pages__list');
	const eappsLink = document.querySelector('.eapps-link');
	const contactForms = document.querySelectorAll('.contact-form');

	AOS.init();

	if(eappsLink) {
		setTimeout(()=> {
			eappsLink.remove();
		}, 500);
	}

	if(contactForms) {
		setTimeout(()=> {
			contactForms.forEach(function(contactForm) {
				contactForm.style.opacity = 1;
			});
		}, 800);
	}

	if(firstSlide) {
		firstSlide.classList.add('animation');
	}

	if(interiorHeaderMain) {
		interiorHeaderMain.classList.add('animation');
	}

	//aos init
	setTimeout(()=> {
		AOS.refresh();
	}, 500);

	if (procedures) {
		setTimeout(()=> {
			AOS.refresh();
		}, 1000);
	}
	proceduresFilter();

	function initAcc(elem, option){
        document.addEventListener('click', function (e) {
            if (!e.target.matches(elem+' .procedures-accordion__btn')) return;
            else{
                if(!e.target.parentElement.classList.contains('active')){
                    if(option==true){
                        var elementList = document.querySelectorAll(elem +' .procedures-accordion__container');
                        Array.prototype.forEach.call(elementList, function (e) {
                            e.classList.remove('active');
                        });
                    }
                    e.target.parentElement.classList.add('active');
                }else{
                    e.target.parentElement.classList.remove('active');
                }
            }
        });
    }

    //activate accordion function
    initAcc('.procedures-accordion__wrapp', true);
}



// WEBPACK FOOTER //
// ./scripts/main.js